import { createAction, props } from '@ngrx/store';
import { IAuditLog } from './audit-log.interface';
import { IResponseError } from '../../service/interface';
import { OrderBy } from '../../../shared/enums';
import { IPagination } from '../shared/interface';

// ── API ──

const loadAuditLogs = createAction('[AuditLog/API] Load Audit Logs');

const loadAuditLogsSuccess = createAction(
	'[AuditLog/API] Load Audit Logs Success',
	props<{ auditLogs: IAuditLog[]; pagination: IPagination }>(),
);

const loadAuditLogsError = createAction(
	'[AuditLog/API] Load Audit Logs Error',
	props<{ error: IResponseError }>(),
);

// ── UI ──

const setOffset = createAction(
	'[AuditLog/UI] Set Offset',
	props<{ offset: number }>(),
);

const setLimit = createAction(
	'[AuditLog/UI] Set Limit',
	props<{ limit: number }>(),
);

const setSortOrder = createAction(
	'[AuditLog/UI] Set SortBy OrderBy',
	props<{ sortBy: string; orderBy: OrderBy }>(),
);

const clearSortOrder = createAction('[AuditLog/UI] Clear SortBy OrderBy');

const setFilter = createAction(
	'[AuditLog/UI] Set AuditLog Filter',
	props<{
		data: {
			[key: string]: string | number | undefined | string[];
		};
	}>(),
);

const resetFilter = createAction('[AuditLog/UI] Reset Filter');

const clearAuditLogError = createAction('[AuditLog/UI] Clear AuditLog Error');

export const AuditLogActions = {
	// API
	loadAuditLogs,
	loadAuditLogsSuccess,
	loadAuditLogsError,
	// UI
	setOffset,
	setLimit,
	setSortOrder,
	clearSortOrder,
	setFilter,
	resetFilter,
	clearAuditLogError,
};
